import React from "react";
import { connect } from "react-redux";
import Stepper from "react-stepper-horizontal";
import {
  Button,
  TextBox,
  CheckBox,
  Validator,
  Popup,
  ValidationGroup,
} from "devextreme-react";
import { push } from "connected-react-router";
import styles from "../../../styles/stylesgenerales";
import logo from "../../../images/logoachs.png";
import logoEmail from "../../../images/emailSended.png";
import CreatePassword from "./CrearPassword/view";
import ValidateUserInfo from "./ValidarDatosPersonales/view";
import { paths } from "../../../config/routes";
import { sendEmailApp } from "../../Global/actions";
import { stepsRegistroNuevoFlujo } from "./registroOpciones";
import {
    EnvioEmailSMSActivacionCuenta,
    renderRedirectFlujoValidacionIdentidad
} from '../RecuperarPassword/actions';
import { createUserAD, doConditions, setUserInfo } from "./actions";
import LoadingOverlay from "../../Shared/LoadingOverlay";
import Step1 from "../RecuperarPassword/DatosPersonales/Step1";
import Iframe from "react-iframe";
import { envioEmailSMSActivacionCuentaNoSerie } from "../../../services/ValidacionIdentidad";
import { doSendNewSolicitud } from '../../SucursalVirtual/Trabajador/Solicitudes/SolicitudesPendientes/actions';
import { createSolicitudADApi } from '../../../services/solicitudesApi';
import { phoneNumberInsert } from '../phoneNumberInsert';


const isAbleLoginAv1 = process.env.REACT_APP_IS_ABLE_LOGIN_AV1 === 'true'  ? true : false;
class Registro extends React.Component {
  constructor(props) {
    super(props);
    if(!isAbleLoginAv1) window.location.href = '/achs/recupera-o-activa/ingresa-tu-rut';
  }
  state = {
    correoReenviado: false,
    cambiado: false,
    telefonoRegistro: "",
    emailRegistro: "",
    emailRepeatRegistro: "",
    checkBox: false,
    isValid: true,
    isPopupVisible: false,
  };
  getActiveStep = () => {
    if (this.props.steps.stepOne) return 0;
    if (this.props.steps.stepTwo) return 1;
    if (this.props.steps.stepThree) return 1;
    if (this.props.steps.stepFour) return 3;
    if (this.props.steps.stepSuccess) return 4;
    if (this.props.steps.stepSeven) return 2;

    return 0;
  };

  setConditions = (e) => {
    this.setState({
      checkBox: e.value,
      isPopupVisible: false,
    });
  };
  handleChange = (e) => {
    const ident = typeof e === "object" ? e.element.id : "";
    //const personalData = { ...this.props.UserInfo };

    switch (ident) {
      case "telefonoRegistro": {
        return this.setState({ telefonoRegistro: e.value || "" });
      }
      case "emailRegistro": {
        return this.setState({ emailRegistro: e.value || "" });
      }
      case "emailRepeatRegistro":
        const isValid = e.value == this.state.emailRegistro;

        return this.setState({
          emailRepeatRegistro: e.value || "",
          isValid,
        });
      default:
        break;
    }
  };
  componentDidMount = () => {
    if (document.getElementById("lt-app-container-publico-home")) {
      document.getElementById("lt-app-container-publico-home").remove();
    }
    if (document.getElementById("lt-app-container-iniciar-chat-publico-home")) {
      document
        .getElementById("lt-app-container-iniciar-chat-publico-home")
        .remove();
    }
    if (document.getElementById("lt-app-container-chat-privado-achs-virtual")) {
      document
        .getElementById("lt-app-container-chat-privado-achs-virtual")
        .remove();
    }
    if (document.getElementById("lt-app-frame-chat-privado-achs-virtual")) {
      document
        .getElementById("lt-app-frame-chat-privado-achs-virtual")
        .remove();
    }
  };

  backToLogin = () => {
    this.props.dispatch(push(paths.root));
  };

  reSendRequest = () => {
    this.props.dispatch(sendEmailApp(this.props.mailActivationAdParams));
    this.setState({ correoReenviado: true });
  };

  // NOTE: COMPONENTE NO USADO, REVISAR EL DE MAS ABAJO!!!!

  // paso cuatro
  renderSuccess() {
    return (
      <center>
        <div className="acceso row">
          <div
            className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"
            style={{ margin: "30px 0" }}
          >
            <img src={logoEmail} alt="Correo enviado" />
          </div>
          <p
            className="tituloLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
            style={{ fontWeight: "bold" }}
          >
            {`Activa tu cuenta, ingresando al link que hemos enviado a tu número
            de teléfono ${this.props.UserInfo.Phone} o al correo electrónico ${this.props.UserInfo.Email}`}
          </p>
          <p
            className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
            style={{ fontSize: "15px", fontWeight: "bold" }}
          >
            {`Si no recibiste el link recuerda revisar la carpeta de SPAM o correos no deseados. Puedes volver a enviar
            el enlace a tu teléfono o correo electrónico haciendo clic en el siguiente botón:`}
          </p>
          <div
            className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
            style={{ textAlign: "center", marginTop: "50px" }}
          >
            <Button
              text="Reenviar link de activación"
              style={{ width: "100%" }}
              type="default"
              onClick={this.reSendRequest}
            />
            {this.state.correoReenviado && (
              <p
                className="tituloLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
                style={{ marginTop: "20px", fontWeight: "bold" }}
              >
                Se ha reenviado el link de activación exitosamente
              </p>
            )}
          </div>
        </div>
      </center>
    );
  }

  /**
   * @description Flujo validacion datos de usuario para el nuevo flujo del registro
   * @author Tony Krikorian <tkrikoriam@achs.cl>
   * @param {*} params
   */
  validarDatosRegistroUsuario = async (params) => {
    //Metodo de DevExtreme para validar el formulario programaticamente
    //const result = params.validationGroup.validate();
    // /**
    //  * Si el formulario es valido, envia los datos al backend para crear el usuario
    //  */
    // if (true) {
    //   // Paso 5
    //   const steps = {
    //     stepOne: false,
    //     stepTwo: false,
    //     stepThree: false,
    //     stepFour: true, // Setea la redirección a la siguiente pantalla CrearPassword
    //     stepSuccess: false,
    //   };
    const personalData = {
      ...this.props.UserInfo,
      Email: this.state.emailRepeatRegistro,
      Phone: this.state.telefonoRegistro,
    };

    //Guarda la info del formulario en Redux Store en UserInfo.
    this.props.dispatch(setUserInfo(personalData));
    if (personalData.TempBD === false) {
      //     // se crea una String random como password y se crea el usuario AD
      personalData.UserType = "emailAddress";
      personalData.Password = Math.random().toString(36).substring(2);
      //     //Ejecuta Action para crear usuario en Azure Active Directory
      await this.props.dispatch(createUserAD(personalData));
    }
  };

  emailComparison = () => {
    return this.state.emailRegistro;
  };

  terminosCodiciones = () => {
    return (
      < >
            <Iframe
            title="iframe-doc"
            scrolling="auto"
            url="/tyc.pdf"
            id="myId"
            className="iframe-conditions"
             width="100%"
             height="90%"
          />
          <div className="checkBoxTerminos col-xl-12">
            <CheckBox
             style={{fontWeight:'bold'}}
              id="checkConditions"
              text="He leído y acepto los términos y condiciones"
              onValueChanged={this.setConditions}
            />
          </div>
      </>
    );
  };
  /**
   * @description Renderiza la pantalla de finalizar registro del nuevo flujo
   */
  renderFinalzarRegistro = () => {
    if (
      this.props.UserInfo.Phone !== this.state.telefonoRegistro &&
      !this.state.cambiado
    ) {
      this.setState({
        telefonoRegistro: this.props.UserInfo.Phone,
        cambiado: true,
      });
    }
    return (
      <ValidationGroup>
        <center>
          <div className="acceso row">
            <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h3>
                <p className="text-left">
                  Teléfono <span className="label-green-requerido">*</span>
                </p>
              </h3>
              <TextBox
                id="telefonoRegistro"
                mask="+56\900000000"
                useMaskedValue
                placeholder="Teléfono"
                maxLength={30}
                onPaste={this.handlePaste}
                valueChangeEvent="keyup"
                maskInvalidMessage="Teléfono inválido"
                onValueChanged={(e) => {
                  this.setState({ telefonoRegistro: phoneNumberInsert(e.previousValue, e.value) });
                }}
                value={this.state.telefonoRegistro}
              >
                <Validator
                  validationRules={[
                    {
                      type: "required",
                      message: "Teléfono es requerido",
                    },
                  ]}
                />
              </TextBox>
            </div>
            <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h3>
                <p className="text-left">
                  Correo electrónico
                  <span className="label-green-requerido"> *</span>
                </p>
              </h3>
              <TextBox
                id="emailRegistro"
                placeholder="ejemplo@email.com"
                ref={(ref) =>
                  ref != null ? (this.emailComponent = ref.instance) : null
                }
                onValueChanged={this.handleChange}
                valueChangeEvent="keyup"
                maxLength={60}
                onFocusOut={this.handleOnFocusEmail}
              >
                <Validator
                  validationRules={[
                    {
                      type: "required",
                      message: "El campo email es requerido",
                    },
                    {
                      type: "email",
                      message: "Debe ingresar un email valido",
                    },
                  ]}
                />
              </TextBox>
            </div>
            <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h3>
                <p className="text-left">
                  Repetir correo electrónico
                  <span className="label-green-requerido"> *</span>
                </p>
              </h3>
              <TextBox
                id="emailRepeatRegistro"
                placeholder="ejemplo@email.com"
                onValueChanged={this.handleChange}
                valueChangeEvent="keyup"
                emailRepeatRegistro
                value={this.state.emailRepeatRegistro}
                maxLength={60}
                onFocusOut={this.handleOnFocusEmail}
              >
                <Validator
                  validationRules={[
                    {
                      type: "required",
                      message: "Se requiere la confirmación de email",
                    },
                    {
                      type: "email",
                      message: "Debe ingresar un email valido",
                    },
                    {
                      type: "compare",
                      message: "El correo electronico no coincide",
                      comparisonTarget: this.emailComparison,
                    },
                  ]}
                />
              </TextBox>
              <p className="input-information text-left">
                {`Recuerda registrar un correo electrónico y teléfono válido. Siempre puedes modificar tus datos en Mi cuenta>Mi perfil de ACHS Virtual.`}
              </p>
            </div>

            <div
              className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
              style={{ textAlign: "center", marginTop: "10px" }}
            >
              <div
                className="checkBoxTerminos col-xl-12"
                onClick={() => {
                  this.setState({ isPopupVisible: true });
                }}
              >
                <CheckBox
                onClick={()=>false}
                  style={{fontWeight:'bold'}}
                  id="checkConditions"
                  text="He leído y acepto los términos y condiciones"
                   readOnly={true}
                  value={this.state.checkBox}
                />
              </div>

              <Button
                disabled={!this.state.checkBox}
                text="Finalizar registro"
                style={{ width: "100%", marginTop: "10px" }}
                type="default"
                onClick={(e) => {
                  let result = e.validationGroup.validate();

                  this.state.telefonoRegistro &&
                    this.state.telefonoRegistro.length > 8 &&
                    result.isValid &&
                    this.validarDatosRegistroUsuario();
                }}
              />
            </div>
          </div>
          <Popup
            visible={this.state.isPopupVisible}
            onHiding={() => this.setState({ isPopupVisible: false })}
            closeOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title="Términos y condiciones"
            height="90vh"
            position="center"
            contentRender={this.terminosCodiciones}
          ></Popup>
          ;
        </center>
      </ValidationGroup>
    );
  };

  /**
   * Pantalla para el envio de SMS e email de activación de cuenta
   */
  renderEnvioEmailSMSSuccess() {
    return (
      <center>
        {/* <div className="acceso row">
          <div
            className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"
            style={{ margin: "10px 0" }}
          >
            <img src={logoEmail} alt="Correo enviado" />
          </div>
          <p
            className="tituloLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
            style={{
              fontWeight: "bold",

              fontSize: "20px",
            }}
          >
            {`Activa tu cuenta, ingresando al link que hemos enviado a tu número
            de teléfono ${
              this.props.phone || this.props.UserInfo.Phone
            } o al correo electrónico ${
              this.props.email || this.props.UserInfo.Email
            }`}
          </p>
          <p
            className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
            style={{ fontSize: "15px", fontWeight: "lighter" }}
          >
            {`Si no recibiste el link recuerda revisar la carpeta de SPAM o correos no deseados. Puedes volver a enviar
            el enlace a tu teléfono o correo electrónico haciendo clic en el siguiente botón:`}
          </p>
          <div
            className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
            style={{ textAlign: "center", marginTop: "20px" }}
          >
            <Button
              text="Reenviar link de activación"
              style={{ width: "100%" }}
              type="default"
              onClick={() => {
                this.setState({ correoReenviado: true });
                this.props.dispatch(
                  EnvioEmailSMSActivacionCuenta(
                    {
                      Phone: this.props.phone || this.props.UserInfo.Phone,
                      Email: this.props.email || this.props.UserInfo.Email,
                      NotificationType: 3,
                    },
                    null,
                    envioEmailSMSActivacionCuentaNoSerie
                  )
                );
              }}
            />
            {this.state.correoReenviado && (
              <p
                className="tituloLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
                style={{ marginTop: "20px", fontWeight: "bold" }}
              >
                Se ha reenviado el link de activación exitosamente
              </p>
            )}
          </div>
        </div> */}
        <div className="acceso row">
          <p
            className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
            style={{
              fontSize: "18px",
              fontWeight: "bolder",
              color: "gray"
            }}
          >
            Link de activación enviado
          </p>
          <p
            className="componentesLogin dataInfo col-xs-12 col-sm-12 col-md-12 col-lg-12"
            style={{
              fontSize: "14px",
              color: "gray",
            }}
          >
            <div className="account-activation-info">
              <p>
                Tu link de activación ha sido enviado a tu correo electrónico y número de teléfono,
                en caso de no recibir el link revisa tu carpeta de Spam y Correos no deseados.
              </p>
              <br/>
              <p><b>Número de teléfono:</b> {this.props.phone || this.props.UserInfo.Phone}</p>
              <p><b>Correo electrónico:</b> {this.props.email || this.props.UserInfo.Email}</p>
            </div>
          </p>
        </div>

        <div
            className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
            style={{ textAlign: "center", marginTop: "-1em" }}
          >
            <div className="registro-botones justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12 boton-achs">
                <Button
                  className="boton-achs secondary"
                  style={styles.fullWidth}
                  text="Reenviar link"
                  type="success"
                  onClick={() => {
                    this.setState({ correoReenviado: true });
                    this.props.dispatch(
                      EnvioEmailSMSActivacionCuenta(
                        {
                          Phone: this.props.phone || this.props.UserInfo.Phone,
                          Email: this.props.email || this.props.UserInfo.Email,
                          NotificationType: 3,
                        },
                        null,
                        envioEmailSMSActivacionCuentaNoSerie
                      )
                    );
                  }}
                />
            </div>

            <div
              className="justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12"
            >
              <div className="contrasena justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <a
                  onClick={() => this.props.dispatch(renderRedirectFlujoValidacionIdentidad())}
                >
                  <span>¿No tienes acceso a este número de teléfono o correo electrónico?</span>
                  <br/>
                  <span>Prueba aquí con otro método</span>
                </a>
              </div>

            </div>
          </div>
      </center>
    );
  }

  render() {
    const activeStep = this.getActiveStep();
    const steps = [
      { title: "Términos y condiciones" },
      { title: "Validar identidad" },
      { title: "Ingresa tus datos" },
      { title: "Contraseña" },
      { title: "Enviar solicitud" },
    ];

    const stepsAD = [
      { title: "Términos y condiciones" },
      { title: "Validar identidad" },
      { title: "Ingresa tus datos" },
    ];

    if (this.props.steps.stepSix === true) {
      return (
        <div
          className="zero row"
          style={{
            justifyContent: "center",
            height: "100%",
            overflowY: "auto",
          }}
        >
          <div className="zero col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-4">
            <div className="zero container-fluid" style={{ minWidth: '38em' }}>
              <div className="zero row">
                <div className="col-12"></div>
              </div>
              <center>
                <div className="zero row">
                  <div className="headerLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <img
                      src={logo}
                      alt=""
                      style={styles.logoLogin}
                      height="65px"
                    />
                  </div>
                </div>
                <div className="zero row">
                  <div className="tituloLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <h2
                      className="titulo-validacion-cuenta"
                      style={{ textAlign: "center", fontSize: 28 }}
                    >
                      {" "}
                      Activación cuenta
                    </h2>
                  </div>
                </div>
                <div className="zero row">
                  {this.props.steps.stepSix &&
                    this.renderEnvioEmailSMSSuccess()}
                </div>
              </center>
            </div>
          </div>
          {this.props.isLoading && <LoadingOverlay />}
        </div>
      );
    } else {
      return (
        <div
          className="zero row"
          style={{
            justifyContent: "center",
            height: "100%",
            overflowY: "auto",
          }}
        >
          <div className="zero col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-4">
            <div className="zero container-fluid" style={{ minWidth: '38em' }}>
              <div className="zero row">
                <div className="col-12"></div>
              </div>
              <center>
                <div className="zero row">
                  <div className="headerLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <img
                      src={logo}
                      alt=""
                      style={styles.logoLogin}
                      height="65px"
                    />
                  </div>
                </div>
                <div className="zero row">
                  <div className="tituloLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <h2 style={{ textAlign: "center", fontSize: 28 }}>
                      {" "}
                      {this.props.steps.stepSeven
                        ? "Registro de usuario y activación de cuenta"
                        : "Registro de usuario y activación de cuenta"}
                    </h2>
                    {!(this.props.emailValid || this.props.rutValid) && (
                      <Stepper
                        className="stepper-registro"
                        activeStep={activeStep}
                        circleTop={15}
                        activeColor="#00963a"
                        completeColor="#0C652F"
                        // steps={this.props.UserInfo.TempBD ? steps : stepsAD}
                        steps={stepsRegistroNuevoFlujo}
                      />
                    )}
                  </div>
                </div>
                <div className="zero row">
                  {/* {this.props.steps.stepOne && <Conditions />} */}
                  {this.props.steps.stepOne && (
                    <Step1
                      dispatch={this.props.dispatch}
                      redireccion={"registro"}
                    />
                  )}
                  {/* {this.props.steps.stepTwo && <PersonalData />} */}
                  {this.props.steps.stepThree && <ValidateUserInfo />}
                  {this.props.steps.stepFour && <CreatePassword />}
                  {this.props.steps.stepSuccess && this.renderSuccess()}
                  {this.props.steps.stepSix &&
                    this.renderEnvioEmailSMSSuccess()}
                  {this.props.steps.stepSeven && this.renderFinalzarRegistro()}

                </div>
              </center>
            </div>
          </div>
          {this.props.isLoading && <LoadingOverlay />}
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  steps: state.userRegister.steps,
  email: state.recover.email,
  phone: state.recover.phone,
  UserInfo: state.userRegister.UserInfo,
  emailValid: state.userRegister.emailValid,
  rutValid: state.userRegister.rutValid,
  isLoading: state.global.isLoading || state.recover.isLoading,
  mailActivationAdParams: state.userRegister.mailActivationAdParams,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Registro);
